// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Global administrators manage recurring work beside the Jobs
 * dashboard that reports its executions. This route supplies the shared system
 * background and content width, while SchedulerManager supplies the schedule
 * heading and controls; rendering another heading here would split one task
 * into two apparent sections.
 */
import { SchedulerManager } from '../components/SchedulerManager';

export default function ScheduledJobsPage() {
  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <SchedulerManager />
      </div>
    </div>
  );
}
